import LayoutContactUs from "../component/LayoutContactUs";
function Home() {
    return (
        <>
            <LayoutContactUs />
        </>
    );
}
export default Home;